export const API_ITEM_LIMIT = 50;
export const SMS_RESEND_TIME = 60;
